"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const trans_1 = require("@common/tsutils/trans");
const Proposal_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Proposal"));
const LifeCycleLine_1 = __importDefault(require("@becrop/components/Modules/Common/Models/LifeCycleLine"));
const TableProjects_vue_1 = __importDefault(require("./TableProjects.vue"));
const TableSummaryProjectsList_vue_1 = __importDefault(require("./TableSummaryProjectsList.vue"));
const TableTrials_vue_1 = __importDefault(require("./TableTrials.vue"));
const TableStudies_vue_1 = __importDefault(require("./TableStudies.vue"));
const TableSummaryTrials_vue_1 = __importDefault(require("./TableSummaryTrials.vue"));
const TooltipAccessCompositionTool_vue_1 = __importDefault(require("../CompositionTool/components/TooltipAccessCompositionTool.vue"));
const axios_1 = __importDefault(require("axios"));
const moment_1 = __importDefault(require("moment"));
let ProposalDetailYield = class ProposalDetailYield extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.data = null;
        this.qrIdCurrent = 0;
        this.reportVisibility = '';
        this.isToastTrials = false;
        this.textSearch = '';
        this.criteria = '';
        this.direction = 0;
        this.feedbackToast = {
            status: false,
            message: '',
            errors: [],
        };
        this.newVisibility = false;
        this.isFeedbackToastActive = false;
        /*     theadElements = [
                {
                    name: trans('results.projects.table.type'),
                    slug: 'type',
                },
                {
                    name: trans('results.projects.table.crop'),
                    slug: 'crop',
                },
                {
                    name: trans('results.projects.table.area'),
                    slug: 'area',
                },
                {
                    name: trans('results.projects.table.ext'),
                    slug: 'ext',
                },
                {
                    name: trans('results.projects.table.cat'),
                    slug: 'category',
                },
            ];
        
            theadElementsTrials = [
                {
                    name: trans('results.projects.table.type'),
                    slug: 'type',
                    order: false,
                },
                {
                    name: 'Crop',
                    slug: 'crop',
                    order: false,
                },
                {
                    name: trans('results_view_map.trials.name'),
                    slug: 'name',
                    order: true,
                },
                {
                    name: 'Report at',
                    slug: 'report_at',
                    order: true,
                },
                {
                    name: trans('results_view_map.trials.times'),
                    slug: 'times',
                    order: false,
                },
                {
                    name: trans('results_view_map.trials.locs'),
                    slug: 'locs',
                    order: false,
                },
                {
                    name: trans('results_view_map.trials.acts'),
                    slug: 'acts',
                    order: false,
                },
            ]; */
        this.currentProposal = new Proposal_1.default({
            id: 0,
            name: '',
            code_name: '',
            accepted_at: '',
            contact: {
                name: '',
                email: '',
            },
            status: {
                slug: '',
                name: '',
                phase: '',
            },
            deliverables: [],
        });
        this.fixedProjectLines = [];
        this.allTrials = [];
        this.filterAllTrials = [];
        this.isTableTrials = false;
        this.reportVisibilityTrials = 'private';
        this.fake = [
            {
                id: 87,
                name: 'Azekiel Bednar',
                version: 2,
                product_id: null,
                productsample_id: 33620,
                product_treatment: 'Iure corrupti nihil qui itaque.',
                crop_id: 163,
                is_std: false,
                synced_at: null,
                airflow_at: null,
                report_at: null,
                stages: [],
                reports2: [],
                crop: {
                    id: 163,
                    name: 'Potato',
                    logo_name: 'tuber',
                },
                time_reports: [],
            },
            {
                id: 87,
                name: 'Dzekiel Bednar',
                version: 2,
                product_id: null,
                productsample_id: 33620,
                product_treatment: 'Iure corrupti nihil qui itaque.',
                crop_id: 163,
                is_std: false,
                synced_at: null,
                airflow_at: null,
                report_at: null,
                stages: [],
                reports2: [],
                crop: {
                    id: 163,
                    name: 'Potato',
                    logo_name: 'tuber',
                },
                time_reports: [],
            },
            {
                id: 87,
                name: 'Ezekiel Bednar',
                version: 2,
                product_id: null,
                productsample_id: 33620,
                product_treatment: 'Iure corrupti nihil qui itaque.',
                crop_id: 163,
                is_std: false,
                synced_at: null,
                airflow_at: null,
                report_at: null,
                stages: [],
                reports2: [],
                crop: {
                    id: 163,
                    name: 'Potato',
                    logo_name: 'tuber',
                },
                time_reports: [],
            },
            {
                id: 87,
                name: 'Czekiel Bednar',
                version: 2,
                product_id: null,
                productsample_id: 33620,
                product_treatment: 'Iure corrupti nihil qui itaque.',
                crop_id: 163,
                is_std: false,
                synced_at: null,
                airflow_at: null,
                report_at: null,
                stages: [],
                reports2: [],
                crop: {
                    id: 163,
                    name: 'Potato',
                    logo_name: 'tuber',
                },
                time_reports: [],
            },
            {
                id: 87,
                name: 'Bzekiel Bednar',
                version: 2,
                product_id: null,
                productsample_id: 33620,
                product_treatment: 'Iure corrupti nihil qui itaque.',
                crop_id: 163,
                is_std: false,
                synced_at: null,
                airflow_at: null,
                report_at: null,
                stages: [],
                reports2: [],
                crop: {
                    id: 163,
                    name: 'Potato',
                    logo_name: 'tuber',
                },
                time_reports: [],
            },
        ];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    // @Prop() study_summary?: boolean;
    // @Prop() study_options?: any;
    toggleComparison() {
        const lastTrialsIDKey = 'lastTrialsID';
        const lastTrialsNameKey = 'lastTrialsName';
        const projectBagId = this.currentProposal.deliverables[0].project_id;
        let url = `/results/project/${projectBagId}/summary/trials`;
        localStorage.setItem(lastTrialsIDKey, '');
        localStorage.setItem(lastTrialsNameKey, '');
        window.location.href = url;
    }
    get finishedTrials() {
        return this.allTrials.filter((t) => t.reports2.length > 0);
    }
    get AvailableComparation() {
        const allowedVersions = new Set();
        this.allTrials.map((t) => t.reports2.map((report) => allowedVersions.add(report.version)));
        return allowedVersions.size == 1
            && this.allTrials.map((t) => t.reports2.length > 0).length > 1;
    }
    toastActiveTrials(value) {
        this.isToastTrials = true;
        this.reportVisibilityTrials = value;
        setTimeout(() => {
            this.isToastTrials = false;
        }, 5000);
        const projects = [];
        this.currentProposal.deliverables.forEach((d) => {
            if (d.type === 'trials') {
                this.callAllTrials(`/data/results/trials/${d.project_id}`);
                this.isTableTrials = true;
            }
            d.areas.forEach((a) => {
                projects.push({
                    type: d.type,
                    area: a,
                    category: d.category,
                    project_id: d.project_id,
                    visibility: d.visibility,
                });
            });
        });
    }
    reloadTrial(id) {
        const projects = [];
        this.currentProposal.deliverables.forEach((d) => {
            if (d.type === 'trials') {
                this.callAllTrials(`/data/results/trials/${d.project_id}`);
                this.isTableTrials = true;
            }
            d.areas.forEach((a) => {
                projects.push({
                    type: d.type,
                    area: a,
                    category: d.category,
                    project_id: d.project_id,
                    visibility: d.visibility,
                });
            });
        });
        for (const trial of this.allTrials) {
            if (trial.id === id) {
                this.qrIdCurrent = trial.qr;
            }
        }
    }
    get thead() {
        let head = [];
        if (this.isTableTrials) {
            head = [
                {
                    name: (0, trans_1.trans)('results.projects.table.type'),
                    slug: 'type',
                    order: false,
                },
                {
                    name: 'Crop',
                    slug: 'crop',
                    order: false,
                },
                {
                    name: (0, trans_1.trans)('results_view_map.trials.name'),
                    slug: 'name',
                    order: true,
                },
                {
                    name: 'Report at',
                    slug: 'report_at',
                    order: true,
                },
                {
                    name: (0, trans_1.trans)('results_view_map.trials.times'),
                    slug: 'times',
                    order: false,
                },
                {
                    name: (0, trans_1.trans)('results_view_map.trials.locs'),
                    slug: 'locs',
                    order: false,
                },
                {
                    name: (0, trans_1.trans)('results_view_map.trials.version'),
                    slug: 'version',
                    order: false,
                },
                {
                    name: (0, trans_1.trans)('results_view_map.trials.acts'),
                    slug: 'acts',
                    order: false,
                },
            ];
        }
        else {
            head = [
                {
                    name: (0, trans_1.trans)('results.projects.table.type'),
                    slug: 'type',
                },
                {
                    name: (0, trans_1.trans)('results.projects.table.crop'),
                    slug: 'crop',
                },
                {
                    name: (0, trans_1.trans)('results.projects.table.area'),
                    slug: 'area',
                },
                {
                    name: (0, trans_1.trans)('results.projects.table.ext'),
                    slug: 'ext',
                },
            ];
            if (this.hasRate) {
                head.push({
                    name: (0, trans_1.trans)('results.projects.table.cat'),
                    slug: 'category',
                });
            }
        }
        return head;
    }
    get isTooltipCompositorAccess() {
        if (this.isBMK &&
            this.hasConditionsDisplayAccessCompositionTool &&
            !this.loading) {
            return true;
        }
        else {
            return false;
        }
    }
    get isBMK() {
        if (this.data.biome_level >= 1)
            return true;
        return false;
    }
    get hasRate() {
        if (this.fixedProjectLines.some((p) => p.type === 'rate'))
            return true;
        return false;
    }
    get hasConditionsDisplayAccessCompositionTool() {
        var _a, _b, _c, _d, _e, _f;
        let isLeastTwoRateProjects = false;
        let isLeastTwoProjectsSameCategory = false;
        let isLeastTwoAreaSameCrop = false;
        const categories = { AAA: 0, AA: 0, A: 0, B: 0, C: 0, D: 0 };
        const ratesDeliverables = [];
        for (const deliverable of this.proposal.deliverables) {
            if (deliverable.type === 'rate' && deliverable.category !== '-') {
                ratesDeliverables.push(deliverable);
                for (const ratesDeliverable of ratesDeliverables) {
                    for (const area of ratesDeliverable.areas) {
                        if (ratesDeliverables.length > 0) {
                            if (((_a = area.meta) === null || _a === void 0 ? void 0 : _a.category) === 'A++') {
                                categories.AAA += ratesDeliverable.areas.length;
                            }
                            if (((_b = area.meta) === null || _b === void 0 ? void 0 : _b.category) === 'A+') {
                                categories.AA += ratesDeliverable.areas.length;
                            }
                            if (((_c = area.meta) === null || _c === void 0 ? void 0 : _c.category) === 'A') {
                                categories.A += ratesDeliverable.areas.length;
                            }
                            if (((_d = area.meta) === null || _d === void 0 ? void 0 : _d.category) === 'B') {
                                categories.B += ratesDeliverable.areas.length;
                            }
                            if (((_e = area.meta) === null || _e === void 0 ? void 0 : _e.category) === 'C') {
                                categories.C += ratesDeliverable.areas.length;
                            }
                            if (((_f = area.meta) === null || _f === void 0 ? void 0 : _f.category) === 'D') {
                                categories.D += ratesDeliverable.areas.length;
                            }
                            if (categories.AAA >= 2 ||
                                categories.AA >= 2 ||
                                categories.A >= 2 ||
                                categories.B >= 2 ||
                                categories.C >= 2 ||
                                categories.D >= 2) {
                                isLeastTwoRateProjects = true;
                                isLeastTwoProjectsSameCategory = true;
                            }
                        }
                    }
                }
            }
        }
        let areTwoOrMoreAreasWithSameCrop = false;
        const cropByCategory = {};
        for (const item of this.proposal.deliverables) {
            const category = item.category;
            for (const area of item.areas) {
                const crop = area.meta.crop.name;
                if (cropByCategory[category]) {
                    if (cropByCategory[category] === crop) {
                        areTwoOrMoreAreasWithSameCrop = true;
                        break;
                    }
                }
                cropByCategory[category] = crop;
            }
            if (areTwoOrMoreAreasWithSameCrop) {
                isLeastTwoAreaSameCrop = true;
                break;
            }
        }
        if (isLeastTwoRateProjects &&
            isLeastTwoProjectsSameCategory &&
            isLeastTwoAreaSameCrop) {
            return true;
        }
        else {
            return false;
        }
    }
    hasTootipAccessCompositionTool() {
        const allAreasRate = [];
        const allRateDeliverables = this.proposal.deliverables.filter((deliverable) => {
            return deliverable.type === 'rate';
        });
        for (const deliverable of allRateDeliverables) {
            for (const area of deliverable.areas) {
                allAreasRate.push(area);
            }
        }
    }
    get zeroViewTriggered() {
        if (this.fixedProjectLines.length === 0 &&
            this.allTrials.length === 0 &&
            this.studyProjects.length === 0) {
            return true;
        }
        return false;
    }
    /*    const plotsFilter = this.plots;
        if (textSearch.length > 0) {
            this.plotsFilter = plotsFilter.filter((plot: plot_i) => {
                return (
                    plot.client_id
                        .toString()
                        .toLowerCase()
                        .includes(textSearch.trim().toLowerCase()) ||
                    plot.user_name
                        .toString()
                        .toLowerCase()
                        .includes(textSearch.trim().toLowerCase())
                );
            });
        } else {
            this.plotsFilter = this.plots;
            return this.plots;
        } */
    get studyProjects() {
        const projects = [];
        if (this.currentProposal.deliverables) {
            this.currentProposal.deliverables
                .filter((d) => d.type === 'study')
                .forEach((d) => {
                projects.push({
                    type: d.type,
                    area: null,
                    project_id: d.project_id,
                    visibility: d.visibility,
                });
            });
        }
        return projects;
    }
    filterAllTrialFn(textSearch) {
        this.filterAllTrials = this.allTrials;
        if (textSearch.length > 0) {
            this.filterAllTrials = this.filterAllTrials.filter((trial) => {
                return (trial.id
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(textSearch.toLowerCase().trim()) ||
                    trial.name
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(textSearch.toLowerCase().trim()) ||
                    this.getAllTimesForTrial(trial)
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(textSearch.toLowerCase().trim()) ||
                    this.getAllLocationsForTrial(trial)
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(textSearch.toLowerCase().trim()) ||
                    (this.formattedDayMonth(trial === null || trial === void 0 ? void 0 : trial.report_at) +
                        this.formattedYear(trial === null || trial === void 0 ? void 0 : trial.report_at))
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(textSearch.toLowerCase().trim()));
            });
        }
        else {
            this.filterAllTrials = this.allTrials;
            return this.allTrials;
        }
    }
    formattedDayMonth(rawDate) {
        let theDate = '';
        if (rawDate) {
            theDate = (0, moment_1.default)(rawDate).format('DDMMM');
        }
        else {
            theDate = '---';
        }
        return theDate;
    }
    formattedYear(rawDate) {
        let theDate = '';
        if (rawDate) {
            theDate = (0, moment_1.default)(rawDate).format('YYYY');
        }
        else {
            theDate = '---';
        }
        return theDate;
    }
    getAllLocationsForTrial(trial) {
        const STAGES = trial.stages;
        const times = [];
        for (const time of STAGES) {
            times.push(time.location_id);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        return timesUnicos.length;
    }
    getAllTimesForTrial(trial) {
        const STAGES = trial.stages;
        const set = new Set(STAGES);
        const stagesUnicos = [...set];
        const stagesUnicosFilterTime0 = stagesUnicos.filter((item) => {
            return item.time !== 0;
        });
        const times = [];
        for (const time of stagesUnicosFilterTime0) {
            times.push(time);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        return timesUnicos.length;
    }
    dismissFeedbackToast() {
        this.isFeedbackToastActive = false;
    }
    deployFeedbackToast() {
        this.isFeedbackToastActive = true;
    }
    // Function that saves the text entered in the search engine
    onchangesearch(text) {
        this.textSearch = text;
        this.filterLines(text);
        this.filterAllTrialFn(text);
    }
    // Function determining breadcroms activated
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
    get projectLines() {
        const projects = [];
        if (this.currentProposal.deliverables) {
            this.currentProposal.deliverables.forEach((d) => {
                if (d.type === 'trials') {
                    this.callAllTrials(`/data/results/trials/${d.project_id}`);
                    this.isTableTrials = true;
                }
                d.areas.forEach((a) => {
                    projects.push(new LifeCycleLine_1.default({
                        type: d.type,
                        area: a,
                        category: a.meta.category,
                        project_id: d.project_id,
                        visibility: d.visibility,
                    }));
                });
            });
        }
        return projects;
    }
    async callAllTrials(url) {
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.allTrials = response;
            /*   this.allTrials = this.fake; */
            return response;
        }
        catch (error) {
            console.error(error);
        }
    }
    async toggleVisibility(id, newVisibility) {
        const resp = await this.toggleVisibilityProject(id, newVisibility);
        this.newVisibility = newVisibility;
        this.feedbackToast.status = resp.status;
        this.feedbackToast.message = resp.message;
        this.feedbackToast.errors = resp.errors;
        this.deployFeedbackToast();
    }
    mounted() {
        if (!this.proposal) {
            this.currentProposal = new Proposal_1.default({});
        }
        else {
            this.currentProposal = this.proposal;
        }
        this.fixedProjectLines = this.projectLines.sort((a, b) => {
            if (a.type !== b.type) {
                return a.type.localeCompare(b.type);
            }
            return a.area.meta.name.localeCompare(b.area.meta.name);
        });
    }
    orderProjectLines() {
        const projects = [];
        if (this.currentProposal.deliverables) {
            this.currentProposal.deliverables.forEach((d) => {
                d.areas.forEach((a) => {
                    projects.push({
                        type: d.type,
                        area: a,
                        category: d.category,
                        project_id: d.project_id,
                        visibility: d.visibility,
                    });
                });
            });
        }
        /*   if (this.direction === 0) return projects; */
        return this.fixedProjectLines;
    }
    async toggleVisibilityProject(id, newVisibility) {
        const response = {
            status: true,
            message: (0, trans_1.trans)('tracking.set_pub_success'),
            errors: [],
        };
        try {
            const resp = await axios_1.default.get('/rate/' + id + '/setIsPublished');
            this.fixedProjectLines = this.fixedProjectLines.map((p) => {
                const newP = p;
                if (newP.area.meta.report_id === id) {
                    newP.area.meta.report_visibility = newVisibility;
                }
                return newP;
            });
            if (!newVisibility)
                response.message = (0, trans_1.trans)('tracking.set_priv_success');
            return response;
        }
        catch (e) {
            response.status = false;
            response.message = e.response.data.message;
            return response;
        }
    }
    filterLines(cri) {
        this.fixedProjectLines = this.projectLines.filter((pl) => {
            if (cri === '#public') {
                if (pl.area.meta.report_visibility === true ||
                    pl.area.meta.report_visibility === null) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (cri === '#private') {
                if (pl.area.meta.report_visibility === false) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (cri === '#pending') {
                if (pl.area.status.slug !== 'completed') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (pl.type
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.name
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.crop.logo_name
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim()) ||
                    pl.area.meta.crop.name
                        .toLowerCase()
                        .trim()
                        .includes(cri.toLowerCase().trim())) {
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
    updateSortableTrials(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.updateSortTrials();
    }
    updateSortTrials() {
        const myCriteria = this.criteria;
        const myDirection = this.direction;
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        function transformcriteria(c) {
            if (c === 'name')
                return 'name';
            if (c === 'report_at')
                return 'report_at';
            return 'name';
        }
        const keyToSort = transformcriteria(myCriteria);
        const simpleKeys = ['name'];
        const advancedKeys = ['report_at'];
        const advancedKeys_2 = ['area'];
        if (myCriteria !== '') {
            if (this.textSearch.length > 0) {
                this.filterAllTrials = this.filterAllTrials.sort((a, b) => {
                    if (myDirection === -1) {
                        if (simpleKeys.includes(keyToSort)) {
                            return a[keyToSort] > b[keyToSort] ? -1 : 1;
                        }
                        else if (advancedKeys.includes(keyToSort)) {
                            return a[keyToSort] > b[keyToSort] ? -1 : 1;
                        }
                        else {
                            if (advancedKeys.includes(keyToSort)) {
                                return a.area.meta[keyToSort] -
                                    b.area.meta[keyToSort] >=
                                    0 && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else if (advancedKeys_2.includes(keyToSort)) {
                                return a.area.meta.name.trim() >
                                    b.area.meta.name.trim() && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else {
                                return a.area.meta.crop.name >
                                    b.area.meta.crop.name && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                        }
                    }
                    else {
                        if (simpleKeys.includes(keyToSort)) {
                            return a[keyToSort] < b[keyToSort] ? -1 : 1;
                        }
                        else if (advancedKeys.includes(keyToSort)) {
                            return a[keyToSort] < b[keyToSort] ? -1 : 1;
                        }
                        else {
                            if (advancedKeys.includes(keyToSort)) {
                                return b.area.meta[keyToSort] -
                                    a.area.meta[keyToSort] >=
                                    0 && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else if (advancedKeys_2.includes(keyToSort)) {
                                return b.area.meta.name.trim() >
                                    a.area.meta.name.trim() && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else {
                                return a.area.meta.crop.name <
                                    b.area.meta.crop.name && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                        }
                    }
                });
            }
            else {
                this.filterAllTrials = this.allTrials.sort((a, b) => {
                    if (myDirection === -1) {
                        if (simpleKeys.includes(keyToSort)) {
                            return a[keyToSort] > b[keyToSort] ? -1 : 1;
                        }
                        else if (advancedKeys.includes(keyToSort)) {
                            return a[keyToSort] > b[keyToSort] ? -1 : 1;
                        }
                        else {
                            if (advancedKeys.includes(keyToSort)) {
                                return a.area.meta[keyToSort] -
                                    b.area.meta[keyToSort] >=
                                    0 && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else if (advancedKeys_2.includes(keyToSort)) {
                                return a.area.meta.name.trim() >
                                    b.area.meta.name.trim() && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else {
                                return a.area.meta.crop.name >
                                    b.area.meta.crop.name && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                        }
                    }
                    else {
                        if (simpleKeys.includes(keyToSort)) {
                            return a[keyToSort] < b[keyToSort] ? -1 : 1;
                        }
                        else if (advancedKeys.includes(keyToSort)) {
                            return a[keyToSort] < b[keyToSort] ? -1 : 1;
                        }
                        else {
                            if (advancedKeys.includes(keyToSort)) {
                                return b.area.meta[keyToSort] -
                                    a.area.meta[keyToSort] >=
                                    0 && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else if (advancedKeys_2.includes(keyToSort)) {
                                return b.area.meta.name.trim() >
                                    a.area.meta.name.trim() && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                            else {
                                return a.area.meta.crop.name <
                                    b.area.meta.crop.name && a.type === b.type
                                    ? -1
                                    : 1;
                            }
                        }
                    }
                });
            }
        }
        else {
            this.filterAllTrials = this.filterAllTrials.sort((a, b) => {
                return a.type > b.type ? -1 : 1;
            });
        }
    }
    updateSortable(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.updateSort();
    }
    updateSort() {
        const myCriteria = this.criteria;
        const myDirection = this.direction;
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        function transformcriteria(c) {
            if (c === 'type')
                return 'type';
            if (c === 'crop')
                return 'crop';
            if (c === 'area')
                return 'area';
            if (c === 'ext')
                return 'extension';
            if (c === 'category')
                return 'category';
            return 'type';
        }
        const keyToSort = transformcriteria(myCriteria);
        const simpleKeys = ['type'];
        const advancedKeys = ['extension'];
        const advancedKeys_2 = ['area'];
        if (myCriteria !== '') {
            this.fixedProjectLines = this.fixedProjectLines.sort((a, b) => {
                if (myDirection === -1) {
                    if (simpleKeys.includes(keyToSort)) {
                        let fa = a[keyToSort];
                        let fb = b[keyToSort];
                        if (fa === '-')
                            fa = '000';
                        if (fb === '-')
                            fb = '000';
                        return fa > fb ? -1 : 1;
                    }
                    else {
                        if (advancedKeys.includes(keyToSort)) {
                            return a.area.meta[keyToSort] - b.area.meta[keyToSort] >=
                                0 && a.type === b.type
                                ? -1
                                : 1;
                        }
                        else if (advancedKeys_2.includes(keyToSort)) {
                            return a.area.meta.name.trim() >
                                b.area.meta.name.trim() && a.type === b.type
                                ? -1
                                : 1;
                        }
                        else if (keyToSort === 'crop') {
                            return a.area.meta.crop.name > b.area.meta.crop.name &&
                                a.type === b.type
                                ? -1
                                : 1;
                        }
                        else {
                            return a.area.meta.category > b.area.meta.category && a.type === b.type
                                ? -1
                                : 1;
                        }
                    }
                }
                else {
                    if (simpleKeys.includes(keyToSort)) {
                        let fa = a[keyToSort];
                        let fb = b[keyToSort];
                        if (fa === '-')
                            fa = 'zzz';
                        if (fb === '-')
                            fb = 'zzz';
                        return fa < fb ? -1 : 1;
                    }
                    else {
                        if (advancedKeys.includes(keyToSort)) {
                            return b.area.meta[keyToSort] - a.area.meta[keyToSort] >=
                                0 && a.type === b.type
                                ? -1
                                : 1;
                        }
                        else if (advancedKeys_2.includes(keyToSort)) {
                            return b.area.meta.name.trim() >
                                a.area.meta.name.trim() && a.type === b.type
                                ? -1
                                : 1;
                        }
                        else if (keyToSort === 'crop') {
                            return a.area.meta.crop.name < b.area.meta.crop.name &&
                                a.type === b.type
                                ? -1
                                : 1;
                        }
                        else {
                            return a.area.meta.category < b.area.meta.category &&
                                a.type === b.type
                                ? -1
                                : 1;
                        }
                    }
                }
            });
        }
        else {
            this.fixedProjectLines = this.fixedProjectLines.sort((a, b) => {
                return a.type > b.type ? -1 : 1;
            });
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProposalDetailYield.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ProposalDetailYield.prototype, "proposal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalDetailYield.prototype, "loading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProposalDetailYield.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('textSearch')
], ProposalDetailYield.prototype, "filterAllTrialFn", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('direction')
], ProposalDetailYield.prototype, "orderProjectLines", null);
ProposalDetailYield = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            PageHeading: bmk_ui_framework_1.PageHeading,
            Yield: bmk_ui_framework_1.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            Separator: bmk_ui_framework_1.Separator,
            Toasts: bmk_ui_framework_1.Toasts,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            ParcelsIcon: bmk_ui_framework_1.ParcelsIcon,
            Info: lucide_vue_next_1.Info,
            Lock: lucide_vue_next_1.Lock,
            Key: lucide_vue_next_1.Key,
            TableProjects: TableProjects_vue_1.default,
            TableSummaryProjectsList: TableSummaryProjectsList_vue_1.default,
            TableTrials: TableTrials_vue_1.default,
            TableStudies: TableStudies_vue_1.default,
            TableSummaryTrials: TableSummaryTrials_vue_1.default,
            TooltipAccessCompositionTool: TooltipAccessCompositionTool_vue_1.default,
        },
    })
], ProposalDetailYield);
exports.default = ProposalDetailYield;
